import React, { useState, useRef, useMemo } from 'react';
import { Row, Col, Carousel } from 'antd';
import Link from 'next/link';
import Image from 'components/Image';
import CarouselPagination from 'components/CarouselPagination';
import chunk from 'lib/chunkArray';

interface Props {
    gallery: Gallery;
    itemsPerRow?: number;
}

export const GalleryCarousel = ({ gallery, itemsPerRow = 4 }: Props): React.ReactElement => {
    const [index, setIndex] = useState(0);
    const slider = useRef(null);

    const goNext = () => {
        slider.current.next();
    };

    const goPrevious = () => {
        slider.current.prev();
    };
    const slides = useMemo(() => chunk(gallery.images, itemsPerRow), [gallery.images, itemsPerRow]);

    return (
        <Row>
            <Col span={24}>
                <Carousel
                    dots={false}
                    autoplaySpeed={7000}
                    ref={slider}
                    afterChange={(index) => {
                        setIndex(index);
                    }}
                >
                    {slides.map((slide, i) => {
                        return (
                            <div key={`gallery-${gallery.seoSlug}-slide-${i}`}>
                                <Row gutter={24} align="middle">
                                    {slide.map((item, iterator) => (
                                        <Col
                                            span={8}
                                            key={`gallery-${gallery.seoSlug}-slide-${i}-photo-${iterator}`}
                                        >
                                            <Link href={`/galerie/${gallery.seoSlug},${i}`}>
                                                <Image
                                                    type="index"
                                                    src={item}
                                                    width={272}
                                                    height={153}
                                                    alt="gallery"
                                                />
                                            </Link>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        );
                    })}
                </Carousel>
            </Col>
            <Col span={24} style={{ padding: '15px 0 15px 0' }}>
                <Row key={`pagination`}>
                    <Col span={24}>
                        <CarouselPagination
                            goNext={goNext}
                            goPrevious={goPrevious}
                            currentSlide={index}
                            slides={slides}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

GalleryCarousel.whyDidYouRender = false;

export default GalleryCarousel;
